<template>
    <div>
        <b-table-simple small bordered>
            <thead>
                <tr>
                    <th>Status</th>
                    <th>Days</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><strong><em>Default</em></strong></td>
                    <td>
                        <b-input type="number" :value="getDaysForDefault()" @input="daysChange($event, null)"
                            :placeholder="defaultDays?.toString()" min="0" @keydown="preventNegative" />
                    </td>
                </tr>
                <tr v-for="status in statuses" :key="status.value">
                    <td>{{ status.text }}</td>
                    <td>
                        <b-input type="number" :value="getDaysForStatus(status)"
                            @input="daysChange($event, status.value)" :placeholder="defaultDays?.toString()" min="0"
                            @keydown="preventNegative" />
                    </td>
                </tr>
            </tbody>
        </b-table-simple>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PatientAssistanceProgramStatus } from "@/models/PatientAssistanceProgram";

@Component({
    name: "PAPNextTouchField",
})
export default class PAPNextTouchField extends Vue {
    @Prop() value!: any;

    get defaultDays() {
        return this.getDaysForDefault() ?? "3";
    }

    get statuses() {
        return [
            { value: PatientAssistanceProgramStatus.Created, text: "Created" },
            { value: PatientAssistanceProgramStatus.ApplicationSubmitted, text: "Application Submitted" },
            { value: PatientAssistanceProgramStatus.Approved, text: "Approved" },
            { value: PatientAssistanceProgramStatus.Denied, text: "Denied" },
            { value: PatientAssistanceProgramStatus.Deleted, text: "Deleted" },
            { value: PatientAssistanceProgramStatus.AwaitingPatient, text: "Awaiting Patient" },
            { value: PatientAssistanceProgramStatus.AwaitingPrescriber, text: "Awaiting Prescriber" },
            { value: PatientAssistanceProgramStatus.Received, text: "Received" },
        ];
    }

    daysChange(days: number | string, status: PatientAssistanceProgramStatus | null) {
        const currentValue = this.value || [];
        const newValue = currentValue.filter((i: any) => {
            if (status === null) return i.status !== null;
            return i.status !== status;
        });

        if (days !== "" && days !== null && days !== undefined && !isNaN(Number(days))) {
            const numDays = Math.max(0, Math.ceil(Number(days)));
            newValue.push({ status, days: numDays });
        }
        this.$emit("input", newValue);
    }

    preventNegative(event: KeyboardEvent) {
        if (event.key === '-' || event.key === 'Minus') {
            event.preventDefault();
        }
    }

    getDaysForStatus(status: any) {
        if (!this.value) return undefined;
        return this.value.find((i: any) => i.status === status.value)?.days;
    }

    getDaysForDefault() {
        if (!this.value) return undefined;
        return this.value.find((i: any) => i.status === null)?.days;
    }
}

</script>

<style scoped lang="scss">
::v-deep(thead th),
::v-deep(td) {
    padding: 1px 7px !important;
}

::v-deep(td) {
    height: 38px !important;
}

table ::v-deep(.actions) {
    width: 50px;
}

table ::v-deep(.active) {
    width: 40px;
}
</style>
